const {
  REACT_APP_COUNTRY_CODE,
  REACT_APP_ASSETS_URL,
  REACT_APP_CITA_ID,
  REACT_APP_SHIPPING_METHOD,
} = process.env;

const Constants = {
  assetsURL: REACT_APP_ASSETS_URL,
  country: REACT_APP_COUNTRY_CODE,
  isMexico: REACT_APP_COUNTRY_CODE === 'MX',
  isColombia: REACT_APP_COUNTRY_CODE === 'CO',
  isChile: REACT_APP_COUNTRY_CODE === 'CL',
  CitaId: REACT_APP_CITA_ID,
  ShippingId: REACT_APP_SHIPPING_METHOD,
};

export default Constants;
